import { BodyText, ImageWithCustomLoader, LilSquigIcon } from 'design-configuration/components'
import { userProfileRoute } from '@utils/routes'
import { useUserDisplay } from '@/hooks/use-user-display'
import Link from 'next/link'
import { AchievementCommunityUserFragment } from '@/gql/generated/graphql'

export const CommunityUserItem = ({ user }: { user: AchievementCommunityUserFragment }): React.ReactElement => {
  const { displayName } = useUserDisplay({
    name: user.name,
    username: user.username,
    address: user.linked_accounts[0]?.public_address
  })
  const profileUrl = user.username
    ? userProfileRoute(user.username)
    : userProfileRoute(user.linked_accounts[0]?.public_address ?? '')

  return (
    <Link href={profileUrl} className="block h-fit w-fit">
      <div className="border-outline-variant hover:border-outline px-xs py-2xs gap-x-xs flex items-center rounded-full border transition-colors">
        <div className="h-lg w-lg border-outline-variant relative flex flex-shrink-0 items-center justify-center rounded-full border">
          {user.profile_picture?.url ? (
            <ImageWithCustomLoader
              src={user.profile_picture.url}
              alt={`${displayName}'s profile picture`}
              className="rounded-full"
              fill
              style={{ objectFit: 'cover' }}
            />
          ) : (
            <LilSquigIcon className="h-lg w-lg fill-outline-variant" />
          )}
        </div>
        <BodyText>{displayName}</BodyText>
      </div>
    </Link>
  )
}
